import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ressult() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#EB2961" }}>Results</span>
            </h2>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <p>
              Whether you are a professional photographer or an aspiring model,
              Talpool is the perfect networking platform for all forms of
              talents. This web platform is built for the users to come
              together, post casting calls, discover and get discovered and
              create magic together.
            </p>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center"
          >
            <StaticImage
              src="../../../images/case-studies/talpool/result_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1929}
              height={1156}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ressult;
